import {event} from '../modules/event';

var disableHover = function(body){
    var timer;

    event.add(window, 'scroll', function(){
        clearTimeout(timer);
        if(body.className.indexOf(' main-disableHover') === -1) body.className = body.className + ' main-disableHover';

        timer = setTimeout(function(){
            body.className = body.className.replace(' main-disableHover', '');
        },500);
    });
}

export {disableHover};


